import * as fromAgreement from '@bca-agreement/store/agreement.reducer';
import * as fromCompanyData from '@bca-company-data/store/company-data.reducer';
import * as fromCompose from '@bca-compose/store/compose.reducer';
import * as fromConfirmation from '@bca-confirmation/store/confirmation.reducer';
import * as fromReceipt from '@bca-receipt/store/receipt.reducer';
import * as fromApp from '@bca-store/app.reducer';
import * as fromUserData from '@bca-user-data/store/user-data.reducer';
import { ActionReducerMap } from '@ngrx/store/src/models';
import { Action } from '@ngrx/store';

export interface IRootState {
  receipt: fromReceipt.IState;
  app: fromApp.IState;
  compose: fromCompose.IState;
  userData: fromUserData.IState;
  companyData: fromCompanyData.IState;
  agreement: fromAgreement.IState;
  confirmation: fromConfirmation.IState;
}

export const reducers: ActionReducerMap<IRootState> = {
  receipt: fromReceipt.reducer,
  app: fromApp.reducer,
  compose: fromCompose.reducer,
  userData: fromUserData.reducer,
  companyData: fromCompanyData.reducer,
  agreement: fromAgreement.reducer,
  confirmation: fromConfirmation.reducer
};

export const getInitialState = (): IRootState => {
  return {
    receipt: fromReceipt.INITIAL_STATE,
    app: fromApp.INITIAL_STATE,
    compose: fromCompose.INITIAL_STATE,
    userData: fromUserData.INITIAL_STATE,
    companyData: fromCompanyData.INITIAL_STATE,
    agreement: fromAgreement.INITIAL_STATE,
    confirmation: fromConfirmation.INITIAL_STATE
  };
};
